<template>
    <div class="system_approval_detail">
        <!--采购退货审批-->
        <template v-if="approval_type === 'purchase_return'">
            <el-form ref="systemForm" :model="form_detail" label-position="top" size="small">
                <el-row :gutter="16" style="flex-wrap: wrap" type="flex">
                    <el-col :span="24">
                        <el-form-item label="供应商">
                            <div class="detail_value" v-text="form_detail.supplier_name || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="采购编号">
                            <div class="detail_value click_text">
                                <span
                                    @click="handleClickPurchaseDetail(form_detail.purchase_id)"
                                    v-text="form_detail.purchase_num"
                                ></span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退货明细">
                            <el-table :data="form_detail.return_details" border class="custom_table" width="100%">
                                <el-table-column label="退货产品" min-width="194" prop="product_name"></el-table-column>
                                <el-table-column
                                    align="right"
                                    label="退货数量"
                                    prop="num"
                                    width="110"
                                ></el-table-column>
                                <el-table-column
                                    align="right"
                                    label="单价（元）"
                                    prop="price"
                                    width="96"
                                ></el-table-column>
                                <el-table-column
                                    align="right"
                                    label="小计金额（元）"
                                    prop="total_price"
                                    width="124"
                                ></el-table-column>
                                <el-table-column
                                    class-name="tableInputColumn"
                                    label="退货说明"
                                    prop="note"
                                    width="124"
                                ></el-table-column>
                            </el-table>
                            <div class="show_summary">
                                退货总数量：<span
                                    v-text="form_detail.return_details.reduce((total, item) => total + item.num, 0)"
                                ></span>
                                <span class="line"></span>
                                退货总金额：<span
                                    v-text="
                                        form_detail.return_details.reduce(
                                            (total, item) => total + Number(item.total_price),
                                            0
                                        )
                                    "
                                ></span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="退款总金额">
                            <div class="detail_value" v-text="form_detail.total_price || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="form_detail.note" :span="24">
                        <el-form-item label="退货备注">
                            <div class="detail_value" v-text="form_detail.note || '--'"></div>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="form_detail.files.length > 0" :span="24">
                        <el-form-item label="附件">
                            <div class="file_upload_wrap file_upload_detail_wrap">
                                <div v-if="form_detail.files.length === 0" class="file_outer_wrap">--</div>
                                <ul v-else class="upload_file_list upload_file_list_detail">
                                    <li v-for="file in form_detail.files" class="upload_file_item">
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <!--订单代采详情-->
        <template v-else-if="approval_type === 'order_purchase'">
            <el-form :model="form_detail" class="custom_detail_form" label-position="top" size="small">
                <el-form-item label="关联订单">
                    <span
                        class="link-label"
                        @click="handleClickOrderDetail"
                        v-text="business_data.order.order_num"
                    ></span>
                </el-form-item>
                <el-form-item label="关联客户">
                    <span
                        class="link-label"
                        @click="handleClickCustomerDetail"
                        v-text="business_data.customer.name"
                    ></span>
                </el-form-item>
                <el-form-item label="销售">
                    <span v-text="business_data.salesperson.name"></span>
                </el-form-item>
                <el-form-item>
                    <ul class="purchase_table_list">
                        <li v-for="(item, index) in form_detail.purchase_details" class="purchase_details_item">
                            <div class="purchase_details_item_index">
                                <span v-text="'代采' + (index + 1)"></span>
                            </div>
                            <div class="purchase_details_item_content">
                                <el-form :model="item" label-position="top" size="small">
                                    <el-form-item label="供应商（个人或公司名称）" prop="supplier">
                                        <span v-text="item.supplier"></span>
                                    </el-form-item>
                                    <ul class="goods_details_list">
                                        <li
                                            v-for="(goods, goods_index) in item.goods_details"
                                            class="goods_details_item"
                                        >
                                            <div
                                                class="goods_details_index"
                                                v-text="'产品明细' + (goods_index + 1)"
                                            ></div>
                                            <div class="goods_details_content">
                                                <el-form :model="goods" label-position="top" size="small">
                                                    <el-form-item label="产品名称" prop="goods_name">
                                                        <span v-text="goods.goods_name"></span>
                                                    </el-form-item>
                                                    <el-form-item label="单价" prop="price">
                                                        <span v-text="'¥' + goods.price"></span>
                                                    </el-form-item>
                                                    <el-form-item label="数量" prop="num">
                                                        <span v-text="goods.num"></span>
                                                    </el-form-item>
                                                    <el-form-item label="产品总价" prop="subtotal_price">
                                                        <span v-text="'¥' + goods.subtotal_price"></span>
                                                    </el-form-item>
                                                </el-form>
                                            </div>
                                        </li>
                                    </ul>
                                </el-form>
                            </div>
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="代采产品总金额" prop="total_price">
                    <span v-text="'¥' + form_detail.total_price"></span>
                </el-form-item>
                <el-form-item label="总优惠金额" prop="discount_price">
                    <span v-text="form_detail.discount_price ? '¥' + form_detail.discount_price : '--'"></span>
                </el-form-item>
                <el-form-item label="实际代采总金额">
                    <span v-text="'¥' + form_detail.actual_total_price"></span>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <span v-text="form_detail.remarks ? form_detail.remarks : '--'"></span>
                </el-form-item>
                <el-form-item v-if="form_detail.file.length" label="附件">
                    <div class="file_upload_wrap">
                        <ul class="upload_file_list">
                            <li v-for="(file, file_idx) in form_detail.file" class="upload_file_item">
                                <div class="file_left_wrap">
                                    <img
                                        alt=""
                                        class="file_img"
                                        src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                    />
                                    <div class="file_info_wrap">
                                        <p class="file_name" v-text="file.file_name"></p>
                                        <p class="file_size" v-text="file.file_size"></p>
                                    </div>
                                </div>
                                <div class="file_right_wrap">
                                    <el-tooltip content="预览" effect="dark" placement="top">
                                        <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                            <i class="iconfont icon-yanjing"></i>
                                        </span>
                                    </el-tooltip>
                                    <span class="line"></span>
                                    <el-tooltip content="下载" effect="dark" placement="top">
                                        <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                            <i class="iconfont icon-daochu"></i>
                                        </span>
                                    </el-tooltip>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <div v-if="form_detail.order_price_change.length">
                    <div class="page_little_title no_before">
                        <span class="title">订单金额变更信息</span>
                    </div>
                    <ul class="order_price_change_list">
                        <li v-for="item in form_detail.order_price_change" class="order_price_change_item">
                            <div class="field_name" v-text="item.field_name"></div>
                            <div>
                                <span
                                    class="value_text"
                                    v-text="item.old_value.text ? '¥' + item.old_value.text : '--'"
                                ></span>
                                <i class="iconfont icon-youjiantou"></i>
                                <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-form>
        </template>
        <!-- 工单出发 -->
        <template v-else-if="approval_type === 'workorder_travel'">
            <el-form :model="form_detail" class="custom_detail_form" label-position="top" size="small">
                <el-row :gutter="16" style="flex-wrap: wrap" type="flex">
                    <el-col :span="24">
                        <el-form-item label="工单编号">
                            <div>
                                <span v-if="form_detail.workorder_num" class="link-label" @click="handleClickWorkOrderDetail(form_detail.workorder_id, form_detail.workorder_num)" v-text="form_detail.workorder_num">
                                </span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="关联商机">
                            <div>
                                <span
                                    v-if="form_detail.project_name"
                                    class="link-label"
                                    @click="
                                        handleClickRelateProjectDetail({
                                            project_id: form_detail.project_id,
                                            project_name: form_detail.project_name,
                                        })
                                    "
                                    v-text="form_detail.project_name"
                                ></span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="关联订单">
                            <div>
                                <span
                                    v-if="form_detail.order_num"
                                    class="link-label"
                                    @click="
                                        handleClickRelateOrderDetail({
                                            order_id: form_detail.order_id,
                                            order_num: form_detail.order_num,
                                        })
                                    "
                                    v-text="form_detail.order_num"
                                ></span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="出发时间">
                            <div>
                                <span v-text="form_detail.start_date"></span>
                                <span v-text="form_detail.start_time == 1 ? '-上午' : '-下午'"></span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="说明">
                            <div v-text="form_detail.travel_note"></div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <!-- 工单结单 -->
        <template v-else-if="approval_type === 'workorder_finish'">
            <el-form :model="form_detail" class="custom_detail_form" label-position="top" size="small">
                <el-row :gutter="16" style="flex-wrap: wrap" type="flex">
                    <el-col :span="24">
                        <el-form-item label="工单编号">
                            <div>
                                <span v-if="form_detail.workorder_num" class="link-label" @click="handleClickWorkOrderDetail(form_detail.workorder_id, form_detail.workorder_num)" v-text="form_detail.workorder_num">
                                </span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="关联商机">
                            <div>
                                <span
                                    v-if="form_detail.project_name"
                                    class="link-label"
                                    @click="
                                        handleClickRelateProjectDetail({
                                            project_id: form_detail.project_id,
                                            project_name: form_detail.project_name,
                                        })
                                    "
                                    v-text="form_detail.project_name"
                                ></span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="关联订单">
                            <div>
                                <span
                                    v-if="form_detail.order_num"
                                    class="link-label"
                                    @click="
                                        handleClickRelateOrderDetail({
                                            order_id: form_detail.order_id,
                                            order_num: form_detail.order_num,
                                        })
                                    "
                                    v-text="form_detail.order_num"
                                ></span>
                                <span v-else>--</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="结单日期">
                            <div>
                                <span>{{ form_detail.start_date }}{{form_detail.start_time == 1 ? '上午' : '下午' }}</span>
                                <span>-{{ form_detail.end_date }}{{form_detail.end_time == 1 ? '上午' : '下午' }}</span>
                            </div>
                            <div class="date_txt">
                                <span>时长{{ form_detail.duration }}天（{{form_detail.days}}人日）</span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="实施人">
                            <div v-if="form_detail.processing_users && form_detail.processing_users.length">{{ form_detail.processing_users.join("、") }}</div>
                            <span v-else>--</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="实施报告/证明">
                            <ul v-if="form_detail.files.length" class="upload_file_list">
                                <li v-for="(file, file_idx) in form_detail.files" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img
                                            alt=""
                                            class="file_img"
                                            src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                        />
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览" effect="dark" placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="结单描述">
                            <div>{{form_detail.note || '--' }}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <!-- 客户申领 -->
        <template v-else-if="approval_type === 'customer_claim'">
            <el-form :model="form_detail" class="custom_detail_form" label-position="top" size="small">
                <el-form-item label="申领客户">
                    <div v-if="form_detail.customers && form_detail.customers.length" class="select-company">
                        <p v-for="(customerName, customerIndex) in form_detail.customers" :key="customerIndex">
                            {{ form_detail.customers.length > 1 ? customerIndex + 1 + "." : "" }}{{ customerName }}
                        </p>
                    </div>
                    <div v-else>--</div>
                </el-form-item>
            </el-form>
        </template>
        <!--订单售后-->
        <afterSaleApproveDetail
            :after_sales_type="approval_type"
            :business_data="business_data"
            :form_detail="form_detail"
        />
        <el-image
            ref="preview_img"
            :preview-src-list="previewImgList"
            :src="previewImgSrc"
            style="display: none"
        ></el-image>
        <!--采购详情-->
        <PurchaseDetail
            v-if="purchaseDetailVisible"
            :purchaseDetailVisible.sync="purchaseDetailVisible"
            :purchaseId="relatedId"
        />
    </div>
</template>

<script>
import PurchaseDetail from "../../views/pc/Purchase/component/purchase_detail";
import afterSaleApproveDetail from "@/components/mComponents/afterSaleApproveDetail";
import { getOSSData, uploadImg } from "@/utils/uploadOss";
export default {
    name: "systemApprovalDetail",
    components: {
        PurchaseDetail,
        afterSaleApproveDetail,
    },
    props: {
        form_detail: {
            type: [Object, Array],
            required: true,
        }, //审批内容
        business_data: {
            type: Object,
            default: () => {
                return {};
            },
        }, //审批内容
        approval_type: {
            type: String,
            default: "",
        }, // 审批类型
        approvalDetailInfo: {
            type: Object,
            default: () => {
                return {};
            },
        }, // 所有审批数据
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            previewImgList: [],
            previewImgSrc: "",
            purchaseDetailVisible: false,
            relatedId: 0,
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 采购详情
        handleClickPurchaseDetail(purchase_id) {
            this.relatedId = purchase_id;
            this.purchaseDetailVisible = true;
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        //点击订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: this.business_data.order.id,
                    name: this.business_data.order.order_num,
                },
            });
        },

        //点击客户详情
        handleClickCustomerDetail() {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: this.business_data.customer.id,
                    name: this.business_data.customer.name,
                },
            });
        },
        // 关联订单详情
        handleClickRelateOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id,
                    name: row.order_num,
                },
            });
        },

        //点击查看关联商机详情
        handleClickRelateProjectDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: row.project_id,
                    name: row.project_name,
                },
            });
        },
        // 查看工单详情
        handleClickWorkOrderDetail(id,workorder_num) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: id,
                    name: workorder_num,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.system_approval_detail {
    width: 100%;

    .click_text {
        cursor: pointer;
        color: rgba(41, 144, 255, 1);
    }

    ::v-deep .el-form-item__label {
        width: 100%;
        display: inline-flex;
        color: #999999 !important;
        margin-bottom: 0 !important;
    }

    ::v-deep .el-form-item__content {
        line-height: 22px;
    }

    .show_summary {
        line-height: 38px;
        background: rgba(237, 240, 244, 1);
        border-radius: 6px;
        padding: 0 12px;
        box-sizing: border-box;
    }

    .select-company {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        max-height: 236px;
        overflow-y: scroll;
    }
    .date_txt {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}
</style>
